<template>
  <b-modal hide-header hide-footer centered size="lg" id="confirmation-modal" modal-class="pgm">
    <div class="confirmation-modal-content">
      <h5>{{ text }}</h5>
      <div class="confirmation-modal-controls">
        <b-button pill variant="danger" class="px-5" @click="closeModal">No, Cancel</b-button>
        <b-button pill variant="primary" class="px-5" @click="handleAccept">Yes, Delete</b-button>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  methods: {
    openModal() {
      this.$bvModal.show('confirmation-modal');
    },
    closeModal() {
      this.$bvModal.hide('confirmation-modal');
    },
    handleAccept() {
      this.$emit('onAccept', { accept: true });
      this.closeModal();
    },
  },
};
</script>
<style lang="scss" scoped>
.confirmation-modal {
  &-content {
    padding: 1rem;
    display: grid;
    gap: 2rem;
  }
  &-controls {
    display: flex;
    gap: 1rem;
    justify-content: center;
  }
}
</style>
